import * as React from "react";

// import LiveGraph  from '../../../monitoring/pages/LiveGraph';
import FluidMonitoringDashboard from "../../../monitoring/components/FluidMonitoringDashboard";

export default function LiveMonitoringPage() {
  return (
    <>
      <FluidMonitoringDashboard/>
    </>
  );
}